export enum SignScreenType {
	SHORT_APPLICATION = 'SHORT_APPLICATION',
	CLIENT_LK_APPLICATION = 'CLIENT_LK_APPLICATION',
	FULL_APPLICATION = 'FULL_APPLICATION',
	BROKER_CONSENT = 'BROKER_CONSENT',
	BROKER_ANY_DOCS = 'BROKER_ANY_DOCS',
}

export interface SignUIConfigApiModel {
	preset: SignScreenType
	params: {
		logoUri?: string
		brokerOrgName?: string
		brokerOrgPhone?: string
	}
}

export enum SignConsentDocumentId {
	UNIFIED_PERSONALIZED_CONSENT = 'UNIFIED_PERSONALIZED_CONSENT',
	USER_AGREEMENT = 'USER_AGREEMENT',
}

export interface SignDocumentApiModel {
	id: SignConsentDocumentId | string
	name: string
}

export type SignDocumentsApiModel = SignDocumentApiModel[]

export interface SignDocumentDetailsApiModel extends SignDocumentApiModel {
	content: string
}

export interface SignConfigApiModel {
	codeLength: number
	durationBetweenCodeRequests: number
	codeExpirationDuration: number
}

export interface SignUserApiModel {
	phone: string
}

export interface SignVerifyResultApiModel {
	verified: boolean
}
